exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".name{font-weight:700;font-size:14px}.arg-navigate{display:inline-block;padding-top:5px}.formula-name{font-weight:700;font-size:12px}.remove-input{cursor:pointer;color:red;padding:5px;display:inline-block}.row{padding-top:10px;padding-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4ab0c5f8!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DynamicPricingRule/DropComponent.vue
// module id = 882
// module chunks = 2